import sport1 from "./assets/products/sport-bra/img1.jpeg";
import sport2 from "./assets/products/sport-bra/img2.jpeg";
import sport3 from "./assets/products/sport-bra/img3.jpeg";
import sport4 from "./assets/products/sport-bra/img4.jpeg";
import sport5 from "./assets/products/sport-bra/img5.jpeg";
import sport6 from "./assets/products/sport-bra/img6.jpeg";
import sport7 from "./assets/products/sport-bra/img7.jpeg";

export const cardData = [
  {
    id: 1,
    title: "Non-Padded Comfort Bra for Natural Support & Daily Wear",
    price: 999,
    rating: 4.8,
    reviews: 703,
    discount: 50,
    images: [
      "https://images.pexels.com/photos/9456698/pexels-photo-9456698.jpeg",
      "https://images.pexels.com/photos/9456708/pexels-photo-9456708.jpeg",
      "https://images.pexels.com/photos/9456709/pexels-photo-9456709.jpeg",
      "https://images.pexels.com/photos/35043469/pexels-photo-35043469.jpeg",
    ],
  },
  {
    id: 2,
    title: "Padded Lace Push-Up Bra for Lift, Shape & Everyday Glam",
    price: 1299,
    rating: 4.6,
    reviews: 520,
    discount: 60,
    images: [
      "https://images.pexels.com/photos/8783491/pexels-photo-8783491.jpeg",
      "https://images.pexels.com/photos/8783488/pexels-photo-8783488.jpeg",
      "https://images.pexels.com/photos/8783492/pexels-photo-8783492.jpeg",
      "https://images.pexels.com/photos/8783491/pexels-photo-8783491.jpeg",
    ],
  },
  {
    id: 3,
    title: "Seamless Panty for Invisible Fit Under Tight Outfits",
    price: 1999,
    rating: 5,
    reviews: 803,
    discount: 70,
    images: [
      "https://images.pexels.com/photos/7065058/pexels-photo-7065058.jpeg",
      "https://images.pexels.com/photos/7065062/pexels-photo-7065062.jpeg",
      "https://images.pexels.com/photos/7065502/pexels-photo-7065502.jpeg",
      "https://images.pexels.com/photos/7065364/pexels-photo-7065364.jpeg",
    ],
  },
  {
    id: 4,
    title: "High-Support Sports Bra for Intense Workouts & Training",
    price: 1499,
    rating: 4.6,
    reviews: 665,
    discount: 60,
    images: [
      "https://images.pexels.com/photos/33334479/pexels-photo-33334479.jpeg",
      "https://images.pexels.com/photos/33334474/pexels-photo-33334474.jpeg",
      "https://images.pexels.com/photos/33292161/pexels-photo-33292161.jpeg",
      "https://images.pexels.com/photos/33334495/pexels-photo-33334495.jpeg",
    ],
  },
  {
    id: 5,
    title: "Soft & Breathable Lounge Shorts for Indoor Comfort",
    price: 999,
    rating: 4.3,
    reviews: 703,
    discount: 50,
    images: [
      "https://images.pexels.com/photos/11103030/pexels-photo-11103030.jpeg",
      "https://images.pexels.com/photos/11103024/pexels-photo-11103024.jpeg",
      "https://images.pexels.com/photos/11103020/pexels-photo-11103020.jpeg",
      "https://images.pexels.com/photos/11103034/pexels-photo-11103034.jpeg",
    ],
  },
  {
    id: 6,
    title: "Soft & Breathable Lounge Shorts for Indoor Comfort",
    price: 1699,
    rating: 4.3,
    reviews: 703,
    discount: 70,
    images: [
      "https://images.pexels.com/photos/4519489/pexels-photo-4519489.jpeg",
      "https://images.pexels.com/photos/4519494/pexels-photo-4519494.jpeg",
      "https://images.pexels.com/photos/4519500/pexels-photo-4519500.jpeg",
      "https://images.pexels.com/photos/4519477/pexels-photo-4519477.jpeg",
    ],
  },
  {
    id: 7,
    title: "Sport bra for exercise and outdoor activities",
    price: 1499,
    rating: 5,
    reviews: 810,
    discount: 60,
    images: [sport1, sport2, sport3, sport4, sport5, sport6, sport7],
  },
];
